export const breakpointMap = {
  sm: `(min-width: ${640}px)`,
  md: `(min-width: ${768}px)`,
  lg: `(min-width: ${1024}px)`,
  xl: `(min-width: ${1280}px)`,
  "2xl": `(min-width: ${1536}px)`,
} as const;
